import React, { useEffect } from 'react'
import { PageWrapper } from './components/pageWrapper'

const ErrorBrowser = () => {

    useEffect(() => {
        let resizeTimer

        const doResizeHandler = () => {
            let e = document.getElementById("dialog")
            let i = (document.getElementById("dialogBody"), document.documentElement.clientWidth)
            let n = document.documentElement.clientHeight
            let d = 0.5 * (i - 700)
            let t = 0.5 * (n - 200)
            e.style.left = d + "px"
            e.style.top = t + "px"
        }

        const resizeHandler = () => {
            if (null != resizeTimer) {
                clearTimeout(resizeTimer)
                resizeTimer = null
            }
            setTimeout(function () { doResizeHandler() }, 5)
            resizeTimer = setTimeout(function () { doResizeHandler() }, 500)
        }

        doResizeHandler()
        setTimeout(doResizeHandler, 2e3)
        window.addEventListener("resize", resizeHandler, !1)

    }, [])

    return (
        <PageWrapper>
            <div
                style={{
                    opacity: 1,
                    backgroundColor: '#000',
                    width: '100%',
                    height: '100%'
                }}
            >
                <div
                    style={{
                        opacity: 0.3,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        overflow: 'hidden',
                        width: '100%',
                        height: '100%',
                    }}
                >
                </div>
            </div>
            <div
                id="dialog"
                className="kia-light"
                style={{
                    position: 'absolute',
                    left: '200px',
                    top: '300px',
                    color: '#fff',
                }}
            >
                <div
                    style={{
                        width: '700px',
                        height: '50px',
                        top: '-50px'
                    }}
                ></div>
                <div
                    id="dialogBody"
                    style={{
                        width: '700px',
                        height: '70px',
                        whiteSpace: 'pre-wrap',
                        padding: '10px'
                    }}
                >
                    Kia.com utilizes the latest technology for a faster, easy-to-use experience. Unfortunately, this
                    experience is not supported on your web browser and is only be viewable on Chrome, Safari, IE 11, or
                    other modern browsers.
                    <div
                        style={{
                            width: '700px',
                            height: '50px',
                            bottom: '-50px',
                            top: 'auto',
                        }}
                    ></div>
                </div>
            </div>

        </PageWrapper>
    )
}

export default ErrorBrowser
